import * as React from "react";
import { Link } from "react-router-dom";
import { Flex } from "../../../components/atoms/Flex/index";
import Icon from "../../../components/atoms/Icon";
import Loader from "../../../components/atoms/Loader";
import TabsNavi from "../../../components/molecules/TabsNavi";
import {
  OutletContextProps,
  WithRouterProps,
} from "../../../helpers/RouterHelper";
import { AuthenticatedPageCallbacks } from "../../../hocs/enhanceAuthenticatedPage";
import enhanceSectionsSettingsPage from "../../../hocs/enhanceSectionsSettingsPage";
import { SectionDetailInterface } from "../../../interfaces/SectionInterface";
import { ContentIndex } from "./ContentIndex/index";
import styles from "./styles.scss";
import { useSectionsSettingsContentsPage } from "./useSectionsSettingsContentsPage";

interface OwnProps {
  section: SectionDetailInterface;
}

interface Props
  extends WithRouterProps,
    AuthenticatedPageCallbacks,
    OwnProps,
    OutletContextProps {}

const SectionsSettingsContentsPage_: React.FC<Props> = (props) => {
  React.useEffect(() => {
    props.setActiveMenu("courses");
  }, []);
  const {
    isLoading,
    isFetchingNextPage,
    contents,
    isDeleting,
    onDelete,
    tabs,
  } = useSectionsSettingsContentsPage({
    sectionId: props.section.id,
    ltiDeployments: props.section.ltiDeployments,
  });

  return (
    <>
      <TabsNavi tabs={tabs} />
      <Flex justifyContent="flex-end" marginTop="1.4rem" wrap>
        <Link
          to={`/sections/${props.section.id}/settings/content_videos/new`}
          className={`buiButtonBase buiButtonVariantOutline buiButtonSizeSm ${styles.buttonLink}`}
        >
          <Icon name="icon-video" className={styles.icon} />
          動画のURLの登録
        </Link>
        <Link
          to={`/sections/${props.section.id}/settings/content_files/new`}
          className={`buiButtonBase buiButtonVariantOutline buiButtonSizeSm ${styles.buttonLink}`}
        >
          <Icon name="icon-file" className={styles.icon} />
          ファイルの登録
        </Link>
      </Flex>
      <div className={styles.tableWrapper}>
        {!isLoading ? (
          <ContentIndex
            sectionId={props.section.id}
            contents={contents}
            onDelete={onDelete}
            isMutating={isDeleting}
          />
        ) : null}
        <Loader loading={isLoading || isFetchingNextPage} />
      </div>
    </>
  );
};

const pageInfo = {
  title: "コンテンツ",
};

export const SectionsSettingsContentsPage = enhanceSectionsSettingsPage(
  SectionsSettingsContentsPage_,
  pageInfo,
  ["contents"],
);
